import { View } from "react-native";
import { StyleSheet } from "react-native";
import WebView from "react-native-webview";
import useResponsiveScreen from "../../hooks/useResponsiveScreen";

type BuildYoutubeEmbedUrlOptions = {
  videoId: string;
  startTime?: number | null;
  endTime?: number | null;
  autoplay?: boolean;
};

export function buildYoutubeEmbedUrl({
  videoId,
  startTime,
  endTime,
  autoplay = false,
}: BuildYoutubeEmbedUrlOptions): string {
  const params = new URLSearchParams();
  if (startTime != null) params.set("start", String(Math.floor(startTime)));
  if (endTime != null) params.set("end", String(Math.floor(endTime)));
  if (autoplay) {
    params.set("autoplay", "1");
    params.set("playsinline", "1");
  }
  const query = params.toString();
  return query ? `https://www.youtube.com/embed/${videoId}?${query}` : `https://www.youtube.com/embed/${videoId}`;
}

type YoutubeVideoPlayerAdvancedProps = {
  id: string;
  startTime?: number | null;
  endTime?: number | null;
  /** When true, the iframe loads with autoplay + playsinline so the user doesn't have to click play inside the embed. */
  autoplay?: boolean;
};

const YoutubeVideoPlayerAdvanced = ({ id, startTime, endTime, autoplay = false }: YoutubeVideoPlayerAdvancedProps) => {
  const { isMedium } = useResponsiveScreen();

  const videoUrl = buildYoutubeEmbedUrl({ videoId: id, startTime, endTime, autoplay });

  return (
    <View style={!isMedium ? styles.mobileVideoContainer : styles.videoContainer}>
      <WebView
        style={styles.webView}
        source={{
          uri: videoUrl,
        }}
        javaScriptEnabled={true}
        allowsFullscreenVideo={true}
      />
    </View>
  );
};

export default YoutubeVideoPlayerAdvanced;

const styles = StyleSheet.create({
  videoContainer: {
    width: "100%",
    aspectRatio: 16 / 9,
    overflow: "hidden",
  },
  mobileVideoContainer: {
    width: "100%",
    aspectRatio: 16 / 9,
    overflow: "hidden",
  },
  webView: {
    width: "100%",
    height: "100%",
  },
});
